import Vue from 'vue'
import Router from 'vue-router'
import index from '@/view/index'
import websiteinfo from '@/view/websiteinfo'
import parkcode from '@/view/parkcode'
import calWorkHours from '@/view/calWorkHours'
import calWorkHoursv2 from '@/view/calWorkHoursv2'
import common from '@/view/common'
import emoji from '@/view/emoji'
import lottery from '@/view/lottery'
import jsontools from '@/view/jsontools'
import timestamp from '@/view/timestamp'
import shorturl from '@/view/shorturl'
import fileshare from '@/view/fileshare'

// 功能导航页
import opcl from '@/view/opcl'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'index',
      component: index
    },
    {
      path: '/opcl',
      name: 'opcl',
      component: opcl
    },
    {
      path: '/websiteinfo',
      name: 'websiteinfo',
      component: websiteinfo
    },
    {
      path: '/parkcode',
      name: 'parkcode',
      component: parkcode
    },
    {
      path: '/calWorkHours',
      name: 'calWorkHours',
      component: calWorkHours
    },
    {
      path: '/calWorkHoursv2',
      name: 'calWorkHoursv2',
      component: calWorkHoursv2
    },
    {
      path: '/common',
      name: 'common',
      component: common
    },
    {
      path: '/opcl/emoji',
      name: 'emoji',
      component: emoji
    },
    {
      path: '/opcl/lottery',
      name: 'lottery',
      component: lottery
    },
    {
      path: '/opcl/jsontools',
      name: 'jsontools',
      component: jsontools
    },
    {
      path: '/opcl/timestamp',
      name: 'timestamp',
      component: timestamp
    },
    {
      path: '/opcl/shorturl',
      name: 'shorturl',
      component: shorturl
    },
    {
      path: '/opcl/fileshare',
      name: 'fileshare',
      component: fileshare
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js